<div class="status-terminal">
  <span class="badge" [ngClass]="online ? 'text-bg-success' : 'text-bg-danger'">
    {{ online ? 'Online' : 'Sem internet' }}
  </span>
  <div *ngIf="cacheBiometricoValido" class="text-secondary small">
    Cache biometrico: {{ totalFuncionariosCache }} servidores
  </div>
  <div *ngIf="!online && cacheBiometricoValido" class="text-success small">
    Registro offline habilitado neste terminal.
  </div>
  <div *ngIf="!online && !cacheBiometricoValido" class="text-danger small">
    Registro offline indisponivel. Conecte a internet para atualizar o terminal.
  </div>
  <div *ngIf="!online && ultimaConexaoOnline" class="text-secondary small">
    Ultima conexao online: {{ ultimaConexaoOnline | date:'dd/MM/yyyy HH:mm:ss' }}
  </div>
  <div *ngIf="registrosPendentesOffline > 0" class="text-warning small">
    Registros pendentes de sincronizacao: {{ registrosPendentesOffline }}
  </div>
  <div *ngIf="sincronizandoOffline" class="text-secondary small">
    Sincronizando registros pendentes...
  </div>
  <button
    *ngIf="terminalAutorizado && terminalToken"
    type="button"
    class="btn btn-outline-secondary btn-sm"
    (click)="alternarFilaOffline.emit()">
    <i class="bi bi-list-check px-1"></i>
    Fila offline
  </button>
</div>
